import * as React from 'react';
import './style.scss';
import { Link } from 'gatsby-plugin-react-i18next';
import { useI18next } from 'gatsby-plugin-react-i18next';

const IconLink = ({
  href = '#',
  children,
  classes,
  size = '',
  theme,
  target,
  external,
  additional,
  withTail = false,
  lang,
  ...rest
}) => {
  const { language } = useI18next();

  if(withTail) {
    return (
      <a
        {...rest}
        href={href}
        className={`icon-link icon-link--${theme} icon-link--${size} ${
          classes || ''
        }`}
        target={target ? target : '_self'}
      >
        {children}
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <path
            stroke="#B1BCCF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m19 12-6-6m6 6-6 6m6-6H5"
          />
        </svg>
      </a>
    );
  }

  if (additional) {
    return (
      <a {...rest} href={href} className={`icon-link icon-link--${theme} icon-link--${size} ${classes || ''}`} target={target ? target : "_self"}>
        {children}
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M12.2 1.8C11.7029 1.8 11.3 1.39706 11.3 0.9C11.3 0.402944 11.7029 0 12.2 0H17.6C18.0971 0 18.5 0.402944 18.5 0.9V6.3C18.5 6.79706 18.0971 7.2 17.6 7.2C17.1029 7.2 16.7 6.79706 16.7 6.3V3.07279L8.3364 11.4364C7.98492 11.7879 7.41508 11.7879 7.0636 11.4364C6.71213 11.0849 6.71213 10.5151 7.0636 10.1636L15.4272 1.8H12.2ZM3.2 4.5C2.9613 4.5 2.73239 4.59482 2.5636 4.7636C2.39482 4.93239 2.3 5.1613 2.3 5.4V15.3C2.3 15.5387 2.39482 15.7676 2.5636 15.9364C2.73239 16.1052 2.96131 16.2 3.2 16.2H13.1C13.3387 16.2 13.5676 16.1052 13.7364 15.9364C13.9052 15.7676 14 15.5387 14 15.3V9.9C14 9.40294 14.4029 9 14.9 9C15.3971 9 15.8 9.40294 15.8 9.9V15.3C15.8 16.0161 15.5155 16.7028 15.0092 17.2092C14.5028 17.7155 13.8161 18 13.1 18H3.2C2.48392 18 1.79716 17.7155 1.29081 17.2092C0.784463 16.7028 0.5 16.0161 0.5 15.3V5.4C0.5 4.68392 0.784463 3.99716 1.29081 3.49081C1.79716 2.98446 2.48392 2.7 3.2 2.7H8.6C9.09706 2.7 9.5 3.10294 9.5 3.6C9.5 4.09706 9.09706 4.5 8.6 4.5H3.2Z" fill="#1762D3"/>
        </svg>
      </a>  
    )
  } else {
    return (
      external ?
        <a {...rest} href={href} className={`icon-link icon-link--${theme} icon-link--${size} ${classes || ''}`} target={target ? target : "_self"}>
          {children}
          <svg className="icon-link__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z" fill="white" />
          </svg>
        </a>  
      :
        <Link {...rest} language={lang ? lang : language} to={href} className={`icon-link icon-link--${theme} icon-link--${size} ${classes || ''}`} target={target ? target : "_self"}>
          {children}
          <svg className="icon-link__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="currentColor" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z" fill="white" />
          </svg>
        </Link>
    )
  }

}

export default IconLink;
